import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { DICTIONARIES, LANGS } from "./translations";

const LanguageContext = createContext({ lang: "en", setLang: () => {}, t: (s) => s, langs: LANGS });

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(() => {
        try {
            return localStorage.getItem("nx-lang") || "en";
        } catch {
            return "en";
        }
    });

    const setLang = (code) => {
        try {
            localStorage.setItem("nx-lang", code);
        } catch {}
        setLangState(code);
    };

    useEffect(() => {
        document.documentElement.lang = lang;
        document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    }, [lang]);

    const t = useCallback((s) => DICTIONARIES[lang]?.[s] || s, [lang]);

    return (
        <LanguageContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
